import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { BoatOptionsProvider } from "../../Boats/BoatOptionsContext";
import { QuoteCalculatorStep } from "./QuoteCalculatorStep";
import { CreateApplicationStep } from "./CreateApplicationStep";

export function CreateApplicationModal({ open, onClose }) {
  const [step, setStep] = useState("calculate");
  const [quote, setQuote] = useState(null);
  const [boat, setBoat] = useState(null);

  const handleClose = () => {
    setStep("calculate");
    setQuote(null);
    setBoat(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      {/* The list route does not provide BoatOptionsProvider, so the boat-type
          dropdown needs its own provider here. */}
      <BoatOptionsProvider>
        <DialogTitle>
          {step === "calculate"
            ? "Create Application — Quote"
            : "Create Application"}
        </DialogTitle>
        {step === "calculate" ? (
          <QuoteCalculatorStep
            onCancel={handleClose}
            onContinue={(flatQuote, boatDetails) => {
              setQuote(flatQuote);
              setBoat(boatDetails);
              setStep("create");
            }}
          />
        ) : (
          <CreateApplicationStep
            quote={quote}
            boat={boat}
            onCancel={handleClose}
            onClose={handleClose}
          />
        )}
      </BoatOptionsProvider>
    </Dialog>
  );
}
